import { DataRoomStatus, dataRoomStatusValues } from 'further-types/data-room';

export const dataRoomSystemDefaultAgreementParagraphs = [
  'Before you can access this page, you agree to keep strictly confidential all non-public, proprietary or sensitive information disclosed in this page and to use such information solely for the purpose for which it is provided.',
  'You shall not disclose the information to any third party without the prior written consent of $firmname.',
  'You shall protect the information with at least the same degree of care you use to safeguard your own confidential information, but no less than reasonable care.',
  "These obligations shall not apply to information that (i) is or becomes publicly available other than through a breach, (ii) was already lawfully in the Recipient's possession, (iii) is independently developed without reference to the confidential information, or (iv) is required to be disclosed by law or regulation. Upon request, you shall promptly return or destroy any confidential information downloaded from this page and confirm compliance in writing.",
];

export const DataRoomStatusLabels: Record<DataRoomStatus, string> = {
  [DataRoomStatus.Live]: 'Live',
  [DataRoomStatus.Inactive]: 'Not live',
};

export const dataRoomStatusOptions = dataRoomStatusValues.map((value) => ({
  value,
  label: DataRoomStatusLabels[value],
}));
